import { BuildUri } from "./BuildUri";

import { NetworkManager } from "../context";
import { ScheduleReportRequest } from "../requests/ScheduleReportRequest";
import { IdentityExportByEventReportRequest } from "../requests/report/IdentityExportByEventReportRequest";
import { IdentityExportByClientReportRequest } from "../requests/report/IdentityExportByClientReportRequest";
import { PunchClockExportReportRequest } from "../requests/report/PunchClockExportReportRequest";
import { PunchClockErrorNoteReportRequest } from "../requests/report/PunchClockErrorNoteReportRequest";
import { SendEmailRequest } from "../requests/SendEmailRequest";
import { IdentityDossierRequest } from "../requests/report/IdentityDossierRequest";
import { IdentityAccessByClientReportRequest } from "../requests/report/IdentityAccessByClientReportRequest";
import { IdentityAuditLogReportRequest } from "../requests/report/IdentityAuditLogReportRequest";
import { ShiftSpotAuditLogReportRequest } from "../requests/report/ShiftSpotAuditLogReportRequest";
import { AdminEmailRequest } from "../requests/AdminEmailRequest";
import { VisitLogReportRequest } from "../requests/report/VisitLogReportRequest";
import { AbsenceLateReportRequest } from "../requests/report/AbsenceLateReportRequest";

class ReportEndpoints {
    getScheduleReport(request: ScheduleReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/schedule", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getIdentityExportByEventReport(request: IdentityExportByEventReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/identity-export-by-event-report", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getIdentityExportByClientReport(request: IdentityExportByClientReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/identity-export-by-client-report", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getIdentityAccessByClientReport(request: IdentityAccessByClientReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/identity-access-by-client", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getPunchClockExportReport(request: PunchClockExportReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/punch-clock-export", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getPunchClockExportExcel(request: PunchClockExportReportRequest): Promise<Response> {
        return NetworkManager.fetch(
            BuildUri("/report/excel/punch-clock-export", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getPunchClockErrorNoteReport(request: PunchClockErrorNoteReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/punch-clock-error-note", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getPunchClockErrorNoteExcel(request: PunchClockErrorNoteReportRequest): Promise<Response> {
        return NetworkManager.fetch(
            BuildUri("/report/excel/punch-clock-error-note", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getIdentityAuditLogReport(request: IdentityAuditLogReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/identity-audit-log", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getShiftSpotAuditLogReport(request: ShiftSpotAuditLogReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/shift-spot-audit-log", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getIdentityDossier(request: IdentityDossierRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/identity-dossier", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getVisitLogReport(request: VisitLogReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/visit-log-report", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getExtendedScheduleReport(request: Record<string, any>): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/extended-schedule", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    sendReportEmail(request: SendEmailRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/email", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    sendAdminEmail(request: AdminEmailRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/admin-email", {}),
            {
                method: "POST",
                body: request
            }
        );
    }

    getAbsenceLateReport(request: AbsenceLateReportRequest): Promise<any> {
        return NetworkManager.fetch(
            BuildUri("/report/html/absence-late", {}),
            {
                method: "POST",
                body: request
            }
        );
    }
}

export default new ReportEndpoints();